import { useEffect, useRef } from 'react';

export function useInViewOnce(
  onInView: () => void,
  options: IntersectionObserverInit = { threshold: 0.5 },
) {
  const ref = useRef<any>(null);
  const triggered = useRef(false);

  useEffect(() => {
    if (!ref.current || triggered.current) return;

    if (typeof IntersectionObserver !== 'function') {
      triggered.current = true;
      onInView();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      // Initial offscreen and subsequent visible entries can arrive together.
      if (!entries.some((entry) => entry.isIntersecting)) return;

      triggered.current = true;
      onInView();
      observer.disconnect();
    }, options);

    observer.observe(ref.current as any as HTMLElement);

    return () => observer.disconnect();
  }, [onInView, options]);

  return ref;
}
